import escalationWorklistDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
};

const escalationWorklistReducer = escalationWorklistDispatcher(initialState, {
  [escalationWorklistDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),

  [escalationWorklistDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
  [escalationWorklistDispatcher.resetData]: (state, _) => ({
    ...initialState,
  }),
});

export default escalationWorklistReducer;
